import {
  Badge as BadgeView,
  Image,
  ImagePosition,
} from '@silvertours/common-landingpages-view';
import { Image as StyledImage } from './ImageContentBlock.styles';

import {
  HasOptionalAlignmentRules,
  HasSectionTitleRules,
  HasModuleContainerSpacingRules,
  ModuleContainer,
} from '../element';
import { SectionTitle } from '../element/SectionTitle';

export type ImageContentBlockContent = {
  badge?: BadgeView;
  image?: Image;
};

export type ImageContentBlockRules = {
  imagePosition?: ImagePosition;
  isFirstColumn?: boolean;
} & HasOptionalAlignmentRules &
  HasSectionTitleRules &
  HasModuleContainerSpacingRules;

export type ImageContentBlockProps = {
  content: ImageContentBlockContent;
  rules?: ImageContentBlockRules;
};

export const ImageContentBlock = ({
  content: { badge, image },
  rules,
}: ImageContentBlockProps) => {
  if (!image) {
    return null;
  }

  const {
    sectionTitle: sectionTitleRules,
    imagePosition,
    isFirstColumn,
    verticalAlign,
    verticalSpacing,
  } = rules || {};

  return (
    <ModuleContainer
      rules={{
        isFirstColumn,
        verticalSpacing,
      }}
    >
      <SectionTitle
        content={badge}
        rules={{
          sectionTitle: {
            ...sectionTitleRules,
            style: 'default',
          },
          verticalSpacing: { isLargeAtMD: true },
        }}
      />
      <StyledImage
        verticalAlign={verticalAlign}
        {...image}
        roundedBorder
        sizes={
          imagePosition === 'bottom' || imagePosition === 'top'
            ? '(max-width: 1220px) 100vw, 1220px'
            : undefined
        }
      />
    </ModuleContainer>
  );
};
